import { apiConfig } from "@pjs/files";

apiConfig.getFilePreview = (params) => `${window.config.getApiBaseUrl()}File/Preview?id=${params.id}&timeslice=${params.timeslice}`;
